<template>
  <div class="purchase-confirmation-modal">
    <div class="purchase-confirmation-modal__content">
      <h2 class="purchase-confirmation-modal__title">Покупка подписки</h2>
      <p class="purchase-confirmation-modal__message">
        У вас уже есть подписки.<br>
        Вы хотите купить новую подписку или продлить существующую?
      </p>
    </div>
    
    <div class="purchase-confirmation-modal__footer">
      <div class="purchase-confirmation-modal__buttons">
        <BaseButton
          text="Продлить существующую"
          styles="primary-gradient"
          vibration="success"
          @on-submit="handleExtendSubscription"
        />
        <BaseButton
          text="Купить новую"
          styles="secondary-200"
          vibration="success"
          @on-submit="handleNewSubscription"
        />
        <BaseButton
          text="Отмена"
          styles="secondary-100"
          vibration="none"
          @on-submit="handleClose"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/ui/components/Base/BaseButton.vue'
import { SentryService } from '@/shared/lib/sentry/sentryService'

const emit = defineEmits<{
  'new-subscription': []
  'extend-subscription': []
  'close': []
}>()

// Отправляем отчет об открытии модалки
SentryService.trackModalOpen('Подтверждение покупки')

const handleNewSubscription = () => {
  SentryService.trackButtonClick('Купить новую подписку', {
    modal: 'purchase_confirmation'
  })
  emit('new-subscription')
}

const handleExtendSubscription = () => {
  SentryService.trackButtonClick('Продлить существующую', {
    modal: 'purchase_confirmation'
  })
  emit('extend-subscription')
}

const handleClose = () => {
  SentryService.trackButtonClick('Отмена покупки', {
    modal: 'purchase_confirmation'
  })
  SentryService.trackModalClose('Подтверждение покупки')
  emit('close')
}
</script>

<style lang="scss" scoped>
.purchase-confirmation-modal {
  display: flex;
  flex-direction: column;
  text-align: center;

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 20px;
  }

  &__footer {
    margin-top: 24px;
    border-top: 1px solid $secondary-200;
    padding-top: 16px;
  }

  &__title {
    @include h1;
    color: $neutral-100;
    margin-bottom: 20px;
  }

  &__message {
    @include p1-regular;
    color: $neutral-100;
    margin-bottom: 32px;
    line-height: 1.5;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    .button-base-block {
      display: flex;
      height: 48px;

      :deep(button) {
        flex-grow: 1;
        justify-content: center;
      }
    }
  }
}
</style>
